/**
 * Returns the user's IANA timezone identifier (e.g. "Pacific/Auckland").
 */
export function getUserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
